'use client';

export default function BackButton({
    fallbackHref = '/',
    className = '',
    children = 'Go Back',
    ...rest
}) {
    const onClick = (e) => {
        e.preventDefault();
        if (typeof window !== 'undefined') {
            try {
                // If the browser history has previous entries, go back.
                if (window.history.length > 1) {
                    window.history.back();
                    return;
                }
            } catch (_err) {
                // ignore and fall back to location replace
            }
            // fallback: navigate to the server-provided href
            window.location.href = fallbackHref;
        }
    };

    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} cursor-pointer hover:opacity-80 transition-opacity`.trim()}
            {...rest}
        >
            {children}
        </button>
    );
}
